import { gql } from 'graphql-tag';

import { CountryFragments } from './CountryType';

const regionId = gql`
  fragment RegionId on Region {
    id: regionCode
  }
`;

const fishingWaterRegionFields = gql`
  fragment FishingWaterRegionFields on Region {
    ...RegionId
    name
    localName
    licenseInfoUrl
  }
  ${regionId}
`;

const placeRegionFields = gql`
  fragment PlaceRegionFields on Region {
    ...RegionId
    regionCode
    name
    localName
    licenseInfoUrl
  }
  ${regionId}
`;

const regionDetailFields = gql`
  fragment RegionDetailFields on Region {
    ...RegionId
    boundaryLayer {
      countryCode
      stateCode
      boundingBox {
        northEast {
          latitude
          longitude
        }
        southWest {
          latitude
          longitude
        }
      }
    }
    name
    localName
    licenseInfoUrl
    country {
      ...RegionCountryFields
    }
  }
  ${regionId}
  ${CountryFragments.regionCountryFields}
`;

export const RegionFragments = {
  id: regionId,
  fishingWaterRegionFields,
  placeRegionFields,
  detailFields: regionDetailFields,
};
